// @flow
import * as React from 'react'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import type { BookInfoType } from '../../models/Book'
import { FadeInImage } from '@components/shared/FadeInImage'
import { colors } from '@components/shared'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { TagPillRow } from '@components/Tag/TagPillRow'
import TrackTags from '@components/Tag/TrackTags'

export function BookInfo (props: BookInfoType): React.Node {
  const router = useRouter()
  const click = React.useCallback((): void => {
    router.push(props.slug)
  }, [props.slug])
  return (
    <BookInfoContainer>
      <ImageContainer onClick={click}>
        <FadeInImage src={props.imageUrl} width={200} height={300} fill={false}/>
      </ImageContainer>
      <TextContainer>
          <TitleContainer>
            <Link href={props.slug} passHref={true}>
            {props.title}
            </Link>
          </TitleContainer>
        <DescriptionContainer>
          {props.description}
        </DescriptionContainer>
        <TagPillSmall>
          <TrackTags tags={props.tags} maxLines={4} clickable={true}/>
        </TagPillSmall>
        <TagPillLarge>
          <TagPillRow id={props.id} tags={props.tags} />
        </TagPillLarge>
      </TextContainer>
    </BookInfoContainer>
  )
}

const TagPillSmall = styled.div`
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    display: none;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

const TagPillLarge = styled.div`
    display: none;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    display: flex;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
const DescriptionContainer = styled.div`
  font-family: "Good Sans Regular";
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${colors.white};
  margin: 8px 0px;
  ${(props: any): string => config(props).media.xs`
  `}
  ${(props: any): string => config(props).media.sm`
  `}
  ${(props: any): string => config(props).media.md`
    font-size: 14px;
    margin: 16px 0px;
    max-width: 900px;
  `}
  ${(props: any): string => config(props).media.lg`
    font-size: 16px;
  `}
  ${(props: any): string => config(props).media.xl`
  `}
`
const TitleContainer = styled.div`

    a {
        text-decoration: none;
        font-family: "Good Sans Regular";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 125%; /* 125% */
        color: ${colors.white};
    }
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
      a {
          font-size: 18px;
        }
    `}
    ${(props: any): string => config(props).media.md`
      a {
        font-size: 24px;
      }
    `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

const ImageContainer = styled.div`
    width: 160px;
    height: 240px;
    margin-right: 16px;
    flex-shrink: 0;
    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
    width: 200px;
    height: 300px;
    margin-right: 70px;
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`

const BookInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    
    

    ${(props: any): string => config(props).media.xs`
  `}
    ${(props: any): string => config(props).media.sm`
  `}
    ${(props: any): string => config(props).media.md`
  `}
    ${(props: any): string => config(props).media.lg`
  `}
    ${(props: any): string => config(props).media.xl`
  `}
`
